import { render, staticRenderFns } from "./pt-route-create.vue?vue&type=template&id=18df4567&"
import script from "./pt-route-create.vue?vue&type=script&lang=js&"
export * from "./pt-route-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports